<template>
  <div>
    <div>
      <b-card no-body>
        <div>
          <b-row>
            <b-col
              cols="6"
              md="3"
              class="ml-2 mt-2"
            >
              <b-form-group>
                <b-form-input
                  id="v-ref-no"
                  v-model="filters['waybill_number']"
                  placeholder="Search Waybill Number"
                />
              </b-form-group>
            </b-col>
            <b-col class="mr-2 mt-2 d-flex justify-content-end">
              <TableButtons
                :items="rows"
                :json_fieldz="json_fields"
                :name="`Invoice Orders - Page ${page}.xls`"
                :bulkname="`Invoice Orders.xls`"
                :fetch="fetchWaybillForMerchantNoPagination"
                :show-refresh-button="false"
              />
            </b-col>
          </b-row>
          <!-- table -->
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              :fields="fields"
              :items="rows"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              hover
              responsive
              striped
              show-empty
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.value)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary"
                      @click="onClickViewOrder(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.item.order_no }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_name)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder ml-1">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2 ml-1"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(collected_cod)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(cod)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(weight)="data">
                {{ (data.value).toLocaleString() }}
              </template>
              <template #cell(description)="data">
                <div class="d-flex align-items-center width-190 font-weight-bold">
                  {{ data.value || '--' }}
                </div>
              </template>
              <template #cell(order_current_status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row cols="12">
                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block width-100"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  md="9"
                >
                  <span class="text-muted pagination-text mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of
                    {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </div>
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import ViewOrderModal from '@/components/orders/ViewOrderModal.vue'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'

const FinanceRepository = RepositoryFactory.get('finance')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    vSelect,
    OrderStatusBadge,
    ViewOrderModal,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    return {
      id: null,
      avatarText,
      filters: {},
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      form: {},
      showUpdateModal: false,
      modelLoading: false,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      // End BS Table
      pageLength: 20,
      dir: false,
      fields: [
        {
          key: 'waybill_number',
          label: 'Waybill Number',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'merchant_business.business_name',
          label: 'Customer Business',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer',
          sortable: false,
        },
        {
          key: 'customer_email',
          label: 'Customer Contact',
          sortable: false,
        },
        {
          key: 'cod', label: 'COD', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'collected_cod', label: 'Collected COD', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'weight', label: 'Net Weight', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
        },
        {
          key: 'order_current_status.key',
          label: 'Status',
          sortable: false,
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        'Order Number': {
          field: 'order_no',
          callback: value => `"${value}"`,
        },
        'Customer Business': {
          field: 'merchant_business.business_name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        COD: 'cod',
        'Collected COD': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        'Net Weight': 'weight',
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        Description: {
          field: 'description',
          callback: value => `"${value || '--'}"`,
        },
        Status: 'order_current_status.name',
      },
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchWaybillForMerchant()
      },
    },
    deep: true,
    page() {
      this.fetchWaybillForMerchant()
    },
    perPage() {
      this.fetchWaybillForMerchant()
    },
  },
  mounted() {
    // Set the initial number of items
    this.fetchWaybillForMerchant()
  },
  created() {
    this.id = this.$route.params.id
  },
  methods: {
    async fetchWaybillForMerchant() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await FinanceRepository.getInvoiceOrderList(this.page, this.perPage, this.id, this.filterQuery))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchWaybillForMerchantNoPagination() {
      try {
        const { data } = (await FinanceRepository.getInvoiceOrderListNoPagination(this.id, this.filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    resetModal() {
      this.clearOnClick()
    },
    filterQueryUpdate() {
      this.fetchWaybillForMerchant()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchWaybillForMerchant()
    },
    changePage(value) {
      this.perPage = value
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onClickViewOrder(id) {
      if (this.$can('show-orders')) {
        this.$refs.viewOrderModal.openModal(id)
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px) {
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
